export enum ArtifactViewIds {
    notebooks = 'notebooks',
    scopeJobDefinition = 'scopejobdefinitions',
    sparkJobDefinition = 'sparkjobdefinitions',
    sqlScripts = 'sqlscripts',
    kqlScripts = 'kqlscripts',
    powerBI = 'powerBI',
    linkconnections = 'linkconnections',
    storageaccounts = 'storageaccounts',
    blobstorage = 'blobstorage',
    databases = 'databases',
    dataMapper = 'dataMapper',
    sparkConfiguration = 'sparkconfigurations',
    adfDataMapper = 'adfcdc'
}
